import { Helmet } from 'react-helmet-async';

const DEFAULT_OG = 'https://g12labs.com/og-image.png';
const BASE = 'https://app.g12labs.com';

export default function Seo({
  title,
  description,
  path = '/',
  noindex = false,
  image = DEFAULT_OG,
  type = 'website',
  jsonLd,
}) {
  const url = `${BASE}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex
        ? <meta name="robots" content="noindex, follow" />
        : <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="G12 Labs" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@G12Labs" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
